import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { AwardCriterionDto, AwardCriterionType, AwardSubCriterionDto } from "../../../autogen/bff-api";
import {
  AwardCriterionFields,
  type AwardCriterionFormValues,
} from "../../../common/library/fields/AwardCriterionFields";
import { RequirementDialogHeader } from "../../../common/components/RequirementDialogHeader";

// t('New criterion') t('Edit criterion') t('Cancel') t('Save')

export type { AwardCriterionFormValues };

interface Props {
  isOpen: boolean;
  isSaving: boolean;
  mode: "add" | "edit";
  defaultValues?: AwardCriterionFormValues;
  /** Carried through the form untouched so editing a criterion here cannot drop its sub-criteria. */
  subCriteria?: AwardSubCriterionDto[];
  onSubmit: (values: AwardCriterionDto) => Promise<void>;
  onClose: () => void;
  allowedTypes?: AwardCriterionType[];
}

const FORM_ID = "award-criterion-modal-form";

export const AwardCriterionModal = ({
  isOpen,
  isSaving,
  mode,
  defaultValues,
  subCriteria,
  onSubmit,
  onClose,
  allowedTypes,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <RequirementDialogHeader title={t(mode === "edit" ? "Edit criterion" : "New criterion")} />
        <ModalBody>
          <AwardCriterionFields
            formId={FORM_ID}
            defaultValues={defaultValues}
            subCriteria={subCriteria}
            onSubmit={onSubmit}
            allowedTypes={allowedTypes}
          />
        </ModalBody>
        <ModalFooter borderTopWidth="1px" borderColor="smBorder">
          <Flex gap="3">
            <Button variant="outline" onClick={onClose}>
              {t("Cancel")}
            </Button>
            <Button type="submit" form={FORM_ID} colorScheme="teal" isLoading={isSaving}>
              {t("Save")}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
